class PortfolioSaveOptionKey {
    public static readonly Notes = "NotesInboxSettings";
    public static readonly ApssRecent = "ApssRecentInboxSettings";
    public static readonly ApssPurges = "ApssPurgesInboxSettings";
    public static readonly ApssConseilNumerique = "ApssConseilNumerique";
    public static readonly Consultation = "ConsultationRequestsTable";
    public static readonly Request = "ExamRequestsInboxSettings";
    public static readonly PreventiveActivities = "PreventiveActivitiesInbox";
    public static readonly PreventiveRecallList = "PreventiveRecallList";
    public static readonly Fax = "SendFaxInboxSettings";
    public static readonly WorkerClaimForm = "WorkerClaimFormInboxSettings";
    public static readonly PortalSyncHistory = "PortalSyncItemsSettings";
    public static readonly PortalPendingItems = "PortalPendingItemsSettings";
    public static readonly PendingApproval = "PendingApprovalSettings";
}

export { PortfolioSaveOptionKey };
